import { ActionsObservable } from 'redux-observable';

import { showErrorAction, showMessageAction } from 'containers/Notification/actions';
import Organization from 'entities/organization/api';

import { SUBMIT, SubmitAction, submitSuccessAction, submitFailedAction } from './types';

const submit = (action$: ActionsObservable<SubmitAction>) =>
  action$.ofType(SUBMIT).mergeMap(({ data }) =>
    Organization.importOrUpdateGiveIndiaNonprofits(data)
      .mergeMap(() => [
        showMessageAction(
          'GiveIndia import has been scheduled. It may take 5-10 minutes for the whole process to complete. Please verify the import results on the platform!'
        ),
        submitSuccessAction(),
      ])
      .catch(() => [showErrorAction('Import failed'), submitFailedAction()])
  );

export default [submit];
